import React, { useState } from "react";
import { Link } from "react-router-dom";
import companycard from "../../../assets/images/cards.png";
import CDCLogo from "../../../assets/images/CDC Logo.png";
import { Button } from "antd";

const FooterBottomComp = ({ setModalShow, modalShow }) => {

	return (
		<>
			<div className='footer_bottom_wrap'>
				<div className='container'>
					<p>
						© {new Date().getFullYear()} Agahi All Rights Reserved | <span onClick={() => setModalShow(true)} style={{ cursor: "pointer" }}>Privacy Policy</span>
					</p>
					{/* <Button onClick={() => setModalShow(true)} >Disclaimer</Button> */}
					<p>
						Powered by
						<img
							src={CDCLogo}
							width={20}
							alt='image'
							className="mx-2"
						/>
						CDC
						Pakistan.
					</p>
				</div>

			</div>
		</>
	);
};

export default FooterBottomComp;
